import { __rest } from "tslib";
import { createElement } from 'rax';
import classNames from 'classnames';
import Text from 'rax-text';
import View from '../view';
import Icon from '../icon';
const DateTimePicker = (props) => {
    const { prefix = 'mt-', defaultValue, value, defaultText = '选择具体时间', reverseText = '返回选择日期', onChange } = props, others = __rest(props, ["prefix", "defaultValue", "value", "defaultText", "reverseText", "onChange"]);
    const clsPrefix = `${prefix}datepicker`;
    const clses = {
        timeSelectTrigger: `${clsPrefix}-mode-switch`,
    };
    return (<View {...others} className={clses.timeSelectTrigger} onClick={onChange}>
      <Icon type="arrow-left" size="xs" className={classNames({
            [`${clsPrefix}-hide-icon`]: value === 'default',
        })}/>
      <Text>{value === 'default' ? defaultText : reverseText}</Text>
      <Icon type="arrow-right" size="xs" className={classNames({
            [`${clsPrefix}-hide-icon`]: value === 'reverse',
        })}/>
    </View>);
};
export default DateTimePicker;
